module.exports = __webpack_public_path__ + "static/media/outline-sm-white.b9c00653.png";